import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdff8f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Directions" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-4 bg-white rounded" }
const _hoisted_5 = { class: "p-5 flex items-center justify-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_7 = { class: "p-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка направлений...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, " При получении списка направлений произошла ошибка ", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "max-w-full overflow-hidden overflow-x-auto"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_directions_tms_actions = _resolveComponent("directions-tms-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_DirectionsTMSFilters = _resolveComponent("DirectionsTMSFilters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_directions_tms_row = _resolveComponent("directions-tms-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_directions_tms_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createDirection,
          onUpdate: _ctx.updateDirection,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Направления" }),
      _createVNode(_component_new_button, { onClick: _ctx.startCreate }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode("Добавить направление ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_DirectionsTMSFilters, {
      class: "mt-9",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.havePermission('tms.direction-index'))
          ? (_openBlock(), _createBlock(_component_new_button, {
              key: 0,
              loading: _ctx.state.is_excel_loading,
              disabled: _ctx.state.is_excel_loading,
              class: "NewButton--search mr-3",
              onClick: _ctx.downloadReport
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading || _ctx.state.is_failed,
          value: _ctx.state.filters.limit,
          "total-items": _ctx.state.filters.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading || _ctx.state.is_failed,
          "current-page": _ctx.state.filters.current_page,
          "total-pages": _ctx.state.filters.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_9
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_10,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadDirections
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Список направлений пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_directions_tms_row, {
                    column: column,
                    row: row
                  }, null, 8, ["column", "row"])
                ]),
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_new_button, {
                    hint: "Редактировать",
                    class: "primary extra-small",
                    onClick: ($event: any) => (_ctx.startUpdate(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ])
    ])
  ]))
}